export const enUserManagementFlag = {
  CN10title: 'List of user management flags',
  CN10validatDuplicate: 'The admin flag you entered has already been registered',
}
